<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(this.$route.params.id != null ? 'Dettaglio bacheca #' + this.$route.params.id : 'Nuova bacheca')">

                    <b-container fluid class="mx-auto text-left" v-if="showdettaglio2 && (showdettaglio || this.$route.params.id == null)">
                        <b-row class="my-1">
                            <b-col sm="3"><label for="titolo">Titolo:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="bacheca.titolo" id="titolo" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="descrizione">Descrizione:</label></b-col>
                            <b-col sm="9">
                                <b-form-textarea id="descrizione" v-model="bacheca.descrizione" :rows="2"></b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="prezzo">Prezzo €:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="bacheca.prezzo" id="prezzo" type="number"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="socio">Socio:</label></b-col>
                            <b-col sm="9">

                                <b-input-group>
                                    <b-form-input v-model="socioVis" id="socio" type="text" disabled></b-form-input>
                                    <b-input-group-append>
                                        <!-- <b-btn v-show="socioVis !== ''" variant="secondary" @click="delSocio()">Elimina</b-btn> -->
                                        <b-btn v-show="bacheca.id == null" variant="primary" @click="selSocio()">Seleziona</b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                        </b-row>
<!--                         <b-row class="my-1">
                            <b-col sm="3"><label for="indirizzo">Indirizzo:</label></b-col>
                            <b-col sm="9">
                                <b-form-textarea id="indirizzo" v-model="bacheca.indirizzo" :rows="2"></b-form-textarea>
                            </b-col>
                        </b-row> -->
                        <b-row class="my-1">
                            <b-col sm="3"><label for="sitoweb">Sito web:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="bacheca.sitoweb" id="sitoweb" type="text"></b-form-input>
                            </b-col>
                        </b-row>
<!--                         <b-row class="my-1">
                            <b-col sm="3"><label for="facebook">Facebook:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="bacheca.facebook" id="facebook" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="coordinate">Coordinate:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="bacheca.coordinate" id="coordinate" type="text"></b-form-input>
                            </b-col>
                        </b-row> -->
                        <b-row class="my-1">
                            <b-col sm="3"><label for="telefono">Telefono:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="bacheca.telefono" id="telefono" type="text"></b-form-input>
                            </b-col>
                        </b-row>
<!--                         <b-row class="my-1">
                            <b-col sm="3"><label for="gruppowa">Link gruppo WhatsApp:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="bacheca.gruppowa" id="gruppowa" type="text"></b-form-input>
                            </b-col>
                        </b-row> -->
                        <b-row class="my-1">
                            <b-col sm="3"><label for="email">Email:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="bacheca.email" id="email" type="email"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="datainizio">Data inizio:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="bacheca.datainizio" id="datainizio" type="date"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="datafine">Data fine:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="bacheca.datafine" id="datafine" type="date"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="categoria">Categoria:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="bacheca.id_categoria" :options="options_categorie" id="categoria">
                                    <template slot="first">
                                                <!-- this slot appears above the options from 'options' prop -->
                                                <option :value="null" disabled>-- Seleziona --</option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
<!--                         <b-row class="my-1">
                            <b-col sm="3"><label for="giorniprima">Visibilità giorni prima:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="bacheca.giorniprima" id="giorniprima" type="number"></b-form-input>
                            </b-col>
                        </b-row> -->
                        <b-row class="my-1">
                            <b-col sm="3"><label for="visibilità">Visibilità:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="bacheca.visibilita" :options="options_visibilità" id="visibilità">
                                    <template slot="first">
                                                <!-- this slot appears above the options from 'options' prop -->
                                                <option :value="null" disabled>-- Seleziona --</option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="flagatt">Stato:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="bacheca.flagsta" :options="options_stati" id="flagsta">

                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="note">Note:</label></b-col>
                            <b-col sm="9">
                                <b-form-textarea id="note" v-model="bacheca.note" :rows="3"></b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row class="my-1" v-if="bacheca.id != null">
                            <b-col sm="3"><label for="datains">Data inserimento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="bacheca.datains" id="datains" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1" v-if="bacheca.id != null">
                            <b-col sm="3"><label for="uteins">Utente inserimento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="bacheca.uteins" id="uteins" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-3">
                            <b-col sm="6" offset-sm="3" v-show="bacheca.id != null">
                                <b-button block size="md" variant="outline-secondary" v-on:click="allegatiImmagini()">
                                    Allegati e immagini
                                </b-button>
                            </b-col>
                        </b-row>
                        <b-row class="my-3">
                            <b-col sm="6" offset-sm="3">
                                <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                    <div v-if="bacheca.id != null">
                                        Salva
                                    </div>
                                    <div v-else>
                                        Inserisci
                                    </div>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>

    <!-- Modal Component -->
    <b-modal size="lg" v-model="sociModal.show" title="Seleziona il socio">
        <!-- <p class="my-2">Seleziona il socio</p> -->

        <div class="text-left">
            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="sociModal.filter" placeholder="Cerca..." />
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive small id="main-table" striped hover show-empty :items="sociModal.items" :fields="sociModal.fields" :current-page="sociModal.currentPage" :per-page="sociModal.perPage" :filter="sociModal.filter" :sort-by.sync="sociModal.sortBy" :sort-desc.sync="sociModal.sortDesc"
                @filtered="onFiltered">
                <template slot="id" scope="row">{{row.value}}</template>
                <template slot="cognome" scope="row">{{row.value}}</template>
                <template slot="nome" scope="row">{{row.value}}</template>
                <!-- <template slot="matricola" scope="row">{{row.value}}</template> -->
                <template slot="email" scope="row">{{row.value}}</template>
                <template slot="seleziona" scope="row">
                <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-btn size="sm" variant="danger" @click.stop="seleziona(row.item,row.index,$event.target)">Seleziona</b-btn>
            </template>
            </b-table>


            <div class="row my-1">
                <div class="col-md-7 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="sociModal.perPage" v-model="sociModal.currentPage" />
                </div>
                <div class="col-md-5 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="sociModal.pageOptions" v-model="sociModal.perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>


        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="secondary" @click="sociModal.show=false" style="margin: 2px;">
                Chiudi
            </b-btn>
        </div>
    </b-modal>

</div>
</template>

<script>

import {
    NAMESPACE
} from '../config.js'

import {
    ctrlVismenu,
    ctrlViscategoria
} from '../util.js'

import {
    Visibilità,
    Categoria,
    Bacheca
} from '../classes.js'

export default {
    name: 'appdettaglio',
    data: function () {
        return {

            namespace: NAMESPACE,
            bacheca: {
                id: this.$route.params.id || null,
                id_categoria: null,
                id_socio: null,
                titolo: '',
                descrizione: '',
                nomesocio: '',
                cognomesocio: '',
                accountsocio: '',
                indirizzo: '',
                sitoweb: '',
                facebook: '',
                coordinate: '',
                telefono: '',
                email: '',
                datainizio: '',
                datafine: '',
                flagsta: 'I',
                note: '',
                giorniprima: 0,
                datains: null,
                uteins: '',
                visibilita: null,
                gruppowa: '',
                prezzo: null,
            },
            error: '',
            options_visibilità: [],
            options_categorie: [],
            flagTipo: '',
            options_stati: [],
            showerror: false,
            showdettaglio: false,
            showdettaglio2: false,
            dismissSecs: 2,
            dismissCountDown: 0,
            sociModal: {
                show: false,
                items: [],
                fields: {
                    id: {
                        label: '#',
                        sortable: true
                    },
                    cognome: {
                        label: 'Cognome',
                        sortable: true
                    },
                    nome: {
                        label: 'Nome',
                        sortable: true
                    },
                    email: {
                        label: 'Email',
                        sortable: true
                    },
                    seleziona: {
                        label: ' ',
                        'class': 'text-right'
                    }
                },
                currentPage: 1,
                perPage: 5,
                pageOptions: [{
                    text: 5,
                    value: 5
                }, {
                    text: 10,
                    value: 10
                }, {
                    text: 15,
                    value: 15
                }],
                sortBy: null,
                sortDesc: false,
                filter: null,
                totalRowsFilter: null,
            }
        };
    },
    computed:{
        socioVis: {
            // getter
            get: function () {
                if(this.bacheca.id_socio == null || this.bacheca.id_socio == 'null' || parseInt(this.bacheca.id_socio) <= 0){
                    return '';
                }
                else{
                    return this.bacheca.cognomesocio + " " + this.bacheca.nomesocio + " - " + this.bacheca.accountsocio;
                }

            },
            // setter
            set: function (newValue) {

            }
        },
        totalRows: {
            // getter
            get: function () {
                return this.sociModal.totalRowsFilter || this.sociModal.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.sociModal.totalRowsFilter = newValue;
            }
        }
    },
    methods: {
        seleziona(item, index, button) {

            this.bacheca.id_socio = item.id;
            this.bacheca.nomesocio = item.nome;
            this.bacheca.cognomesocio = item.cognome;
            this.bacheca.accountsocio = item.email;

            this.sociModal.show = false;

        },
        allegatiImmagini() {

            this.$router.push({
                path: `/app/allegati/id/${this.bacheca.id}/tipo/${this.flagTipo}`
            });

        },
        selSocio() {

            var token = localStorage.getItem('token');
            //this.axios.get(NAMESPACE + 'rest/soci', {
                this.axios.get(NAMESPACE + 'rest/soci/flgatt/S', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            this.sociModal.items = response.data.message;
                            this.sociModal.items.forEach(function(element, index) {
                                delete element.uteins; //per motivi di ricerca
                            });
                            this.sociModal.show = true;

                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        this.sociModal.showerror = true;
                        this.sociModal.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    this.sociModal.showerror = true;
                    this.sociModal.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.sociModal.currentPage = 1;
        },
        insert() {
            var appdettaglio = this;

            if (this.bacheca.titolo == "") {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo titolo vuoto!";

            } else if (this.bacheca.id_socio == "" || this.bacheca.id_socio == null) {
                appdettaglio.showerror = true;
                appdettaglio.error = "Selezionare il socio!";

            } else if (this.bacheca.descrizione == "") {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo descrizione vuoto!";

            } else if (this.bacheca.id_categoria == null) {
                appdettaglio.showerror = true;
                appdettaglio.error = "Categoria non selezionata!";

            } else if (this.bacheca.datainizio == "" || this.bacheca.datainizio == null) {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo data inizio vuota!";

            } else if (this.bacheca.datafine == "" || this.bacheca.datafine == null) {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo data fine vuota!";

            } else if (this.bacheca.datafine < this.bacheca.datainizio) { //sono stringhe yyyy-mm-dd
                appdettaglio.showerror = true;
                appdettaglio.error = "Data inizio maggiore di data fine!";

            } else if ((this.bacheca.visibilita || '') == '') {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Visibilità non selezionata!";

            } else if (this.bacheca.giorniprima < 0) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Visibilità giorni prima < 0!";

            } else {

                var json = JSON.stringify(this.bacheca);

                var token = localStorage.getItem('token');
                this.axios.post(NAMESPACE + 'rest/bacheca', json, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.bacheca = res[0];
                                    this.showerror = false;
                                    this.showdettaglio = this.showdettaglio2 = true; //anche se non dovrebbe servire
                                    this.dismissCountDown = this.dismissSecs;

                                    this.$router.replace('/app/dettagliobacheca/' + this.bacheca.id);

                                    setTimeout(function() {
                                        //window.history.back();
                                        appdettaglio.$router.go(-1);
                                    }, 2500);

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }

                            } else {
                                throw new Error(response.data.message);
                            }

                        } catch (e) {
                            this.showerror = true;
                            this.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        this.showerror = true;
                        this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });
            }

        }
    },
    created: function () {

        if(!ctrlVismenu("B")){
            this.$router.replace('/accessdenied');
            return;
        }

        var bac = new Bacheca();
        var options = [];
        var listaStati = Object.keys(bac.getListaStati());
        for (var i = 0; i < listaStati.length; i++) {
            options.push({
                value: listaStati[i],
                text: bac.getStatoByFlag(listaStati[i])
            });
        }
        this.options_stati = options;

        var id = this.bacheca.id; //se è la prima volta si prova a prendere da getid
        var token = localStorage.getItem('token');

        if (id != null) {

            var appdettaglio = this;

            this.axios.get(NAMESPACE + 'rest/bacheca/' + id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {
                                appdettaglio.bacheca = res[0];
                                appdettaglio.showdettaglio = true;

                            } else {
                                throw new Error("Errore dati non trovati!");
                            }

                        } else {
                            throw new Error(response.data.message);
                        }

                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        }

        const tipoPagina = 'Bancarella';

        //recupero il valore del flag del tipo della categoria
        var cat = new Categoria();
        var tipi = cat.getListaTipi();
        var keys = Object.keys(tipi);
        var flagTipo = "";
        for (i = 0; i < keys.length; i++) {
            if (tipi[keys[i]] == tipoPagina) {
                flagTipo = keys[i];
            }
        }

        this.flagTipo = flagTipo;

        //chiamo il servizio che mi restituisce tutte le categorie di quel tipo
        this.axios.get(NAMESPACE + 'rest/categorie/tipo/' + flagTipo, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        var res = response.data.message;
                        if (res.length > 0) {

                            var options = [];
                            for (var i = 0; i < res.length; i++) {
                                options.push({
                                    value: res[i].id,
                                    text: res[i].descrizione
                                });
                            }

                            this.options_categorie = options;

                            this.options_categorie = this.options_categorie.filter(function (element) {
                                return ctrlViscategoria(element.value);
                            });

                            if(this.options_categorie.length == 0){
                                throw new Error("Errore categorie per utente non trovate!");
                            }

                            this.showdettaglio2 = true;

                        } else {
                            throw new Error("Errore categorie non trovate!");
                        }


                    } else {
                        throw new Error(response.data.message);
                    }


                } catch (e) {
                    this.showerror = true;
                    this.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                appdettaglio.showerror = true;
                appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });

        //creo la tendina visibilità
        var visibilità = new Visibilità();
        var options_vis = [];
        for (var i = 0; i < Object.keys(visibilità.getListaTipi()).length; i++) {
            options_vis.push({
                value: Object.keys(visibilità.getListaTipi())[i],
                text: visibilità.getTipoByFlag(Object.keys(visibilità.getListaTipi())[i])
            });
        }
        this.options_visibilità = options_vis;


    },
    mounted: function() {

    }

}
</script>
